<template>
    <div id="permission">
        <div class="tree-panel">
            <div class="tree-header">
                <div>
                    <el-button type="primary" size="mini" @click="addPermission(0)" v-if="isShowByPermission('/wyms/permission/insertPermissionZ')">添加</el-button>
                    <el-button type="primary" size="mini" @click="editPermission()" v-if="isShowByPermission('/wyms/permission/updatePermissionZ')">编辑</el-button>
                    <el-button type="danger" size="mini" @click="deletePermission()" v-if="isShowByPermission('/wyms/permission/delPermissionZ')">删除</el-button>
                </div>
                <div>
                    <el-input size="mini" class="search-input " placeholder="应用名称/应用编码"
                              v-model="treeSearchText" @keyup.enter.native="filterTreeHandler">
                        <el-button slot="append" icon="el-icon-search" size="mini"
                                   @click="filterTreeHandler"></el-button>
                    </el-input>
                </div>
            </div>
            <div class="tree-container" :style="{height: `${windowHeight - 190}px`}">
                <el-tree class="filter-tree"
                         highlight-current
                         ref="tree"
                         draggable
                         :allow-drop="allowDropFunc"
                         @node-drop="nodeDropFunc"
                         :data="treeData"
                         :props="defaultProps"
                         :filter-node-method="filterNode"
                         node-key="id"
                         :expand-on-click-node='false'
                         @node-click="nodeClickHandler"
                         :default-expanded-keys="defaultExpandedArray">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span :title="data.name">{{ data.name }}</span>
                    </span>
                </el-tree>
            </div>

        </div>
        <div class="main-panel" :style="{width: `${windowWidth - 580}px`}">
            <div v-show="!isShowPermissionRole">
                <div class="info-line" v-show="permissionDetail.name">
                    <span class="info-line__name">{{permissionDetail.name}}</span>
                    <span>菜单路径：<span class="info-line__value">{{permissionDetail.url}}</span></span>
                    <span>网页显示名称：<span class="info-line__value">{{permissionDetail.description}}</span></span>
                    <span>应用名称：<span class="info-line__value">{{permissionDetail.description}}</span></span>
                </div>
<!--                <div class="title">-->
<!--                    菜单权限-->
<!--                </div>-->
<!--                <div>-->
<!--                    <div class="line">-->
<!--                        <el-row :gutter="20">-->
<!--                            <el-col :span="10">-->
<!--                                <span class="label">菜单名称：</span>-->
<!--                                <span class="value">{{permissionDetail.name}}</span>-->
<!--                            </el-col>-->
<!--                            <el-col :span="10">-->
<!--                                <span class="label">菜单类型：</span>-->
<!--                                <span class="value">{{['', 'pc端', '移动端', '公共'][permissionDetail.label]}}</span>-->
<!--                            </el-col>-->
<!--                        </el-row>-->
<!--                    </div>-->
<!--                    <div class="line">-->
<!--                        <el-row :gutter="20">-->
<!--                            <el-col :span="10">-->
<!--                                <span class="label">菜单路径：</span>-->
<!--                                <span class="value">{{permissionDetail.url}}</span>-->
<!--                            </el-col>-->
<!--                            <el-col :span="10">-->
<!--                                <span class="label">排序：</span>-->
<!--                                <span class="value">{{permissionDetail.sort}}</span>-->
<!--                            </el-col>-->
<!--                        </el-row>-->
<!--                    </div>-->
<!--                    <div class="line">-->
<!--                        <el-row :gutter="20">-->
<!--                            <el-col :span="10">-->
<!--                                <span class="label">页面显示名称：</span>-->
<!--                                <span class="value">{{permissionDetail.description}}</span>-->
<!--                            </el-col>-->
<!--                            <el-col :span="10">-->
<!--                                <span class="label">是否隐藏：</span>-->
<!--                                <span class="value">{{permissionDetail.hidden == 1 ? '显示' : '隐藏'}}</span>-->
<!--                            </el-col>-->
<!--                        </el-row>-->
<!--                    </div>-->
<!--                    <div class="line">-->
<!--                        <el-row :gutter="20">-->
<!--                            <el-col :span="10">-->
<!--                                <span class="label">父类编码：</span>-->
<!--                                <span class="value">{{permissionDetail.pid}}</span>-->
<!--                            </el-col>-->
<!--                            <el-col :span="10">-->
<!--                                <span class="label">应用名称：</span>-->
<!--                                <span class="value">{{permissionDetail.moduleName}}</span>-->
<!--                            </el-col>-->
<!--                        </el-row>-->
<!--                    </div>-->
<!--                    <div class="line">-->
<!--                        <el-row :gutter="20">-->
<!--                            <el-col :span="10">-->
<!--                                <span class="label">系统类别：</span>-->
<!--                                <span class="value">{{permissionDetail.systemType}}</span>-->
<!--                            </el-col>-->
<!--                        </el-row>-->
<!--                    </div>-->
<!--                </div>-->

                <div style="padding-bottom:10px">

                    <el-button type="primary" size="medium" @click="addPermission(1)">添加</el-button>
                      <el-input style="width: 240px" class="search-input search-input--right"
                              size="medium"
                              placeholder="资源名称或资源路径" icon="el-icon-search" @keyup.enter.native="handleInputChange"
                              v-model.trim="resourceName">
                        <el-button slot="append" size="medium" icon="el-icon-search" @click="handleInputChange"></el-button>
                    </el-input>
                </div>
                <el-table
                    :height="windowHeight - 270"
                    :data="resourceList"
                    style="width: 100%" border
                >
                    <el-table-column
                        label="id"
                        prop="id"
                        align="center"
                    >
                    </el-table-column>
                    <el-table-column
                        label="资源名"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <span @click="showPermissionDetail(scope.row)" class="resource-name">
                                {{ scope.row.name }}
                            </span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        label="资源路径"
                        prop="url"
                        align="center"
                        width="240px"
                    >
                    </el-table-column>
                    <el-table-column
                        label="资源属性"
                        align="center"
                    >
                        <template slot-scope="scope">
                            {{ ['菜单', '功能', '应用文件夹'][scope.row.type] }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="资源类型"
                        align="center"
                    >
                        <template slot-scope="scope">
                            {{ {
                            1: 'pc',
                            2: '移动端',
                            3: '公共',
                            }[scope.row.label] }}
                        </template>
                    </el-table-column>
                     <el-table-column
                        label="应用模块"
                        align="center"
                    >
                        <template slot-scope="scope">
                           {{scope.row.moduleName}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                    >
                        <template slot-scope="scope">
                            <el-button type="text" @click="editPermission(scope.row)" v-if="isShowByPermission('/wyms/permission/updatePermissionZ')">编辑</el-button>
                            <el-button type="text" @click="deletePermission(scope.row.id)" v-if="isShowByPermission('/wyms/permission/delPermissionZ')">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination-container">
                    <el-pagination
                        @size-change="queryPermissionByPidFunc"
                        @current-change="queryPermissionByPidFunc"
                        :current-page.sync="pagination.pageNo"
                        :page-sizes="[10 , 20, 30, 50]"
                        :page-size.sync="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :page-count="pagination.pages"
                        :total="pagination.total"
                    >
                    </el-pagination>
                </div>
            </div>
            <div v-show="isShowPermissionRole">
               <div  style="padding-bottom: 10px;border-bottom: 1px solid #e4e7ed;">
                   <el-button size="medium" @click="isShowPermissionRole = false">返回</el-button>
                </div>                
                <div class="title title--large">
                    【{{roleResourceName}}】角色授权信息
                </div>
                <div class="role-list">
                    <div class="role-item" v-for="roleItem in roleList">
                        <el-tag size="mini">{{roleItem}}</el-tag>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog title="新增" :visible.sync="isShowAddPermissionDialog" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form ref="addPermissionForm" :model="addPermissionForm" :rules="permissionFormRules"
                         label-width="120px">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model.trim="addPermissionForm.name" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="路径" prop="url">
                        <el-input v-model.trim="addPermissionForm.url" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="终端类型" prop="label">
                        <el-radio-group v-model="addPermissionForm.label">
                            <el-radio :label="1">PC端</el-radio>
                            <el-radio :label="2">移动端</el-radio>
                            <el-radio :label="3">公共</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="权限类型" prop="type">
                        <el-radio-group v-model="addPermissionForm.type">
                            <el-radio :label="0">菜单</el-radio>
                            <el-radio :label="1">功能</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="页面显示名称" prop="description">
                        <el-input v-model.trim="addPermissionForm.description" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="应用模块">
                        <el-select filterable :filter-method="filterFunc" v-model.trim="addPermissionForm.moduleId" placeholder="请选择">
                            <el-option v-for="item in moduleAppListSelect" :key="item.id" :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowAddPermissionDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="addPermissionConfirm">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑" :visible.sync="isShowEditPermissionDialog" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div class="dialog-form">
                <el-form ref="editPermissionForm" :model="editPermissionForm" :rules="permissionFormRules"
                         label-width="120px">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model.trim="editPermissionForm.name" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="路径" prop="url">
                        <el-input v-model.trim="editPermissionForm.url" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="终端类型" prop="label">
                        <el-radio-group v-model="editPermissionForm.label">
                            <el-radio :label="1">PC端</el-radio>
                            <el-radio :label="2">移动端</el-radio>
                            <el-radio :label="3">公共</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="权限类型" required>
                        <el-radio-group v-model="editPermissionForm.type">
                            <el-radio :label="0">菜单</el-radio>
                            <el-radio :label="1">功能</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="页面显示名称" prop="description">
                        <el-input v-model.trim="editPermissionForm.description" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="应用模块">
                        <el-select filterable v-model.trim="editPermissionForm.moduleId" placeholder="请选择">
                            <el-option v-for="item in moduleAppList" :key="item.id" :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级菜单" prop="pid">
                        <el-tree
                            ref="editTree"
                            check-on-click-node
                            class="filter-tree"
                            :data="treeData"
                            :props="defaultProps"
                            node-key="id"
                            :expand-on-click-node='false'
                            @node-click="editNodeClickHandler"
                            :default-expanded-keys="editExpandArray">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span :title="data.name">{{ data.name }}</span>
                            </span>
                        </el-tree>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowEditPermissionDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="editPermissionConfirm">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="新增" :visible.sync="isShowAddPermissionRootDialog" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form ref="addPermissionRootForm" :model="addPermissionRootForm" :rules="permissionRootFormRules"
                         label-width="120px">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model.trim="addPermissionRootForm.name" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="系统类别" prop="systemType">
                        <el-select filterable v-model.trim="addPermissionRootForm.systemType" placeholder="请选择">
                            <el-option v-for="item in systemTypeList" :key="item.code" :label="item.name"
                                       :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowAddPermissionRootDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="addPermissionRootConfirm">确定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="编辑" :visible.sync="isShowEditPermissionRootDialog" :close-on-press-escape='false'
                   width="600px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div class="dialog-form">
                <el-form ref="editPermissionRootForm" :model="editPermissionRootForm" :rules="permissionRootFormRules"
                         label-width="120px">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model.trim="editPermissionRootForm.name" style="width: 400px;"></el-input>
                    </el-form-item>
                    <el-form-item label="系统类别" prop="systemType">
                        <el-select filterable v-model.trim="editPermissionRootForm.systemType" placeholder="请选择">
                            <el-option v-for="item in systemTypeList" :key="item.code" :label="item.name"
                                       :value="item.code">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="上级菜单" prop="pid">
                        <el-tree
                            ref="editTree"
                            check-on-click-node
                            class="filter-tree"
                            :data="treeData"
                            :props="defaultProps"
                            node-key="id"
                            :expand-on-click-node='false'
                            @node-click="editNodeClickHandler"
                            :default-expanded-keys="editExpandArray">
                            <span class="custom-tree-node" slot-scope="{ node, data }">
                                <span :title="data.name">{{ data.name }}</span>
                            </span>
                        </el-tree>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowEditPermissionRootDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="editPermissionRootConfirm">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize.js';
    import baseMixin from '@/mixins/baseMixin.js';

    import {isShowByPermission} from "@/utils/utils";
    import {
        queryPermissionTree,
        queryPermission,
        insertPermission,
        queryModuleByModel,
        querySysMenuType,
        movingSort,
        updatePermission,
        delPermission,
        queryPermissionByPid,
        queryRolePermGrant
    } from '@/api/permission';

    export default {
        name: "permission",
        mixins: [windowResize, baseMixin],
        data() {
            return {
                treeData: [],
                treeSearchText: '',
                defaultProps: {
                    children: 'childrens',
                    label: 'label'
                },
                currentType: -1,
                currentNode: null,
                defaultExpandedArray: [0],
                editExpandArray: [],
                isShowAddPermissionDialog: false,
                isShowAddPermissionRootDialog: false,
                isShowEditPermissionRootDialog: false,
                moduleAppList: [],
                moduleAppListSelect: [],
                permissionDetail: {
                    name: '',
                    label: '',
                    url: '',
                    sort: '',
                    description: '',
                    hidden: 2,
                    moduleName: '',
                    systemType: '',
                    type: ''
                },
                addPermissionForm: {
                    description: '',
                    label: '',
                    moduleId: '',
                    name: '',
                    systemType: '',
                    url: '',
                    type: ''
                },
                permissionFormRules: {
                    name: [{
                        required: true, message: '请填写名称', trigger: 'blur'
                    }],
                    url: [{
                        required: true, message: '请填写路径', trigger: 'blur'
                    }],
                    label: [{
                        required: true, message: '请选择终端类型', trigger: 'blur'
                    }],
                    type: [{
                        required: true, message: '请选择权限类型', trigger: 'blur'
                    }],
                    description: [{
                        required: true, message: '请填写页面显示名称', trigger: 'blur'
                    }],
                    pid: [{
                        required: true, message: '请选择上级菜单', trigger: 'blur'
                    }]
                },
                addPermissionRootForm: {
                    name: '',
                    systemType: ''
                },
                permissionRootFormRules: {
                    name: [{
                        required: true, message: '请填写名称', trigger: 'blur'
                    }],
                    // systemType: [{
                    //     required: true, message: '请选择系统类别', trigger: 'blur'
                    // }],
                    pid: [{
                        required: true, message: '请选择上级菜单', trigger: 'blur'
                    }]
                },
                systemTypeList: [],

                isShowEditPermissionDialog: false,
                editPermissionForm: {
                    description: '',
                    label: '',
                    moduleId: '',
                    name: '',
                    systemType: '',
                    url: '',
                    pid: '',
                    type: ''

                },
                editPermissionRootForm: {
                    name: '',
                    systemType: '',
                    pid: ''
                },
                downLoadHref: '',
                uploadPath: '',
                uploadData: {
                    curriculumId: '',
                    curriculumName: '',
                    departId: '',
                    departName: '',
                    examType: '',
                    id: '',
                    name: '',
                    score: ''
                },
                resourceName: '',
                resourceList: [],
                isShowPermissionRole: false,
                roleList: [],
                roleResourceName: ''
            }
        },
        created() {
            this.queryPermissionTreeFunc();
            querySysMenuType()
                .then(data => {
                    this.systemTypeList = data;
                })
        },
        methods: {
            isShowByPermission,
            filterFunc(searchText) {
                this.moduleAppListSelect = this.moduleAppList.filter(item => {
                    return `${item.code}`.includes(`${searchText}`) || item.name.includes(`${searchText}`);
                });

            },
            showPermissionDetail(item) {
                this.roleResourceName = item.name;
                queryRolePermGrant({
                    id: item.id
                })
                    .then(data => {
                        this.isShowPermissionRole = true;
                        this.roleList = data;
                    })
            },
            filterTreeHandler() {
                this.treeSearchText = this.treeSearchText.trim();
                this.$refs.tree.filter();
            },
            handleInputChange() {
                this.pagination.pageNo = 1;
                this.queryPermissionByPidFunc();
            },
            queryPermissionByPidFunc() {
                queryPermissionByPid({
                    id: this.currentNode ? this.currentNode.id : 0,
                    names: this.resourceName,
                    pageSize: this.pagination.pageSize,
                    pageNo: this.pagination.pageNo
                })
                    .then(data => {
                        this.resourceList = data.dataList;
                        this.pagination.total = data.pagination.total;
                    })
            },
            queryPermissionTreeFunc() {
                queryPermissionTree({
                    menu: true
                })
                    .then(data => {
                        this.treeData = [data];
                    })
            },
            filterNode(value, data) {
                return `${data.t}`.includes(this.treeSearchText) || data.name.includes(this.treeSearchText)
            },
            allowDropFunc(draggingNode, dropNode, type) {
                return type !== 'inner' && dropNode.data.id != 0;
            },
            nodeDropFunc(draggingNode, dropNode, type) {
                if (type !== 'inner') {
                    console.log(dropNode);
                    const pNode = dropNode.parent.data;
                    console.log({
                        id: dropNode.data.pid,
                        sort: pNode.childrens && pNode.childrens.length !== 0 ? pNode.childrens.length : 1
                    });
                    // movingSort({
                    //     id: dropNode.data.pid,
                    //     sort:pNode.childrens && pNode.childrens.length !== 0 ? pNode.childrens[pNode.childrens.length - 1].sort + 1 : 1
                    // })
                }
            },
            nodeClickHandler(node) {
                this.currentNode = node;
                let pNode = this.$refs.tree.getNode(this.currentNode.id);
                const parentIdList = [];
                while (!!pNode.parent) {
                    if(node.level != 0) {
                        parentIdList.unshift(pNode.data.id);
                    }
                    pNode = pNode.parent;
                }
                parentIdList.unshift(0);
                this.defaultExpandedArray = parentIdList;
                this.isShowPermissionRole = false;
                queryPermission({
                    id: node.id
                })
                    .then(data => {
                        this.permissionDetail = data || {
                            name: '',
                            label: '',
                            url: '',
                            sort: '',
                            description: '',
                            hidden: 2,
                            moduleName: '',
                            systemType: '',
                        };
                    });
                this.queryPermissionByPidFunc();

            },
            editNodeClickHandler(node) {
                this.editPermissionForm.pid = node.id;
            },
            deletePermission(id) {
                if (!id && this.currentNode === null) {
                    this.$message.error('请选择一个节点');
                } else if (!id && this.currentNode.id == 0) {
                    this.$message.error('不可删除根节点');
                } else {
                    this.$confirm("确认要删除吗？", "删除", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                        lockScroll: false
                    }).then(() => {
                        delPermission({
                            ids: id || this.currentNode.id
                        })
                            .then(() => {
                                this.$message.success('删除成功');
                                if(!id) {
                                    this.currentNode = null;
                                }
                                this.queryPermissionTreeFunc();
                                this.queryPermissionByPidFunc();
                            })
                    });
                }
            },


            addPermission(type) {
                if (this.currentNode === null) {
                    this.$message.error('请选择一个节点');
                } else {
                    // this.currentType = type;

                    if (this.currentNode.id == 0) {
                        this.addPermissionRootForm = {
                            name: '',
                            systemType: ''
                        };
                        this.isShowAddPermissionRootDialog = true;
                    } else {
                        queryModuleByModel()
                            .then(data => {
                                this.addPermissionForm = {
                                    description: '',
                                    label: '',
                                    moduleId: '',
                                    name: '',
                                    systemType: '',
                                    url: ''
                                };
                                this.isShowAddPermissionDialog = true;
                                this.moduleAppList = data || [];
                                this.moduleAppListSelect = data ? JSON.parse(JSON.stringify(data)) : [];
                            });
                    }

                }
            },
            addPermissionConfirm() {
                this.$refs.addPermissionForm.validate(isValid => {
                    if (isValid) {
                        const args = {
                            description: this.addPermissionForm.description,
                            label: this.addPermissionForm.label,
                            moduleId: this.addPermissionForm.moduleId,
                            systemType: '',
                            pid: this.currentNode.id,
                            url: this.addPermissionForm.url,
                            name: this.addPermissionForm.name,
                            type: this.addPermissionForm.type
                        };
                        insertPermission(args)
                            .then(() => {
                                this.isShowPermissionRole = false;
                                this.$message.success('新增成功');
                                this.isShowAddPermissionDialog = false;
                                this.queryPermissionTreeFunc();
                                this.queryPermissionByPidFunc();
                            });
                    }
                })
            },
            addPermissionRootConfirm() {
                this.$refs.addPermissionRootForm.validate(isValid => {
                    if (isValid) {
                        const args = {
                            description: '',
                            label: '',
                            moduleId: '',
                            systemType: this.addPermissionRootForm.systemType,
                            pid: this.currentNode.id,
                            url: '',
                            name: this.addPermissionRootForm.name,
                            type: this.currentType
                        };
                        insertPermission(args)
                            .then(() => {
                                this.isShowPermissionRole = false;

                                this.$message.success('新增成功');
                                this.isShowAddPermissionRootDialog = false;
                                this.queryPermissionTreeFunc();
                                this.queryPermissionByPidFunc();

                            });
                    }
                })
            },
            editPermission(menuNode = null) {
                if (this.currentNode === null && menuNode === null) {
                    this.$message.error('请选择一个节点');
                } else {
                    if(menuNode === null) {
                        this.currentType = this.permissionDetail.type;
                        this.editPermissionForm = JSON.parse(JSON.stringify(this.permissionDetail));
                        this.editPermissionRootForm = JSON.parse(JSON.stringify(this.permissionDetail));
                        this.editPermissionForm.id = this.currentNode.id;
                        this.editPermissionForm.pid = this.currentNode.pId;

                        this.editPermissionRootForm.id = this.currentNode.id;
                        this.editPermissionRootForm.pid = this.currentNode.pId;

                    } else {
                        this.currentType = menuNode.type;

                        this.editPermissionForm = JSON.parse(JSON.stringify(menuNode));
                        this.editPermissionRootForm = JSON.parse(JSON.stringify(menuNode));
                        this.editPermissionForm.id = menuNode.id;
                        this.editPermissionForm.pid = menuNode.pid;

                        this.editPermissionRootForm.id = menuNode.id;
                        this.editPermissionRootForm.pid = menuNode.pid;

                    }

                    let node = this.$refs.tree.getNode(menuNode ? menuNode.pid : this.currentNode.pId);

                    const parentIdList = [];
                    if(menuNode) {
                        parentIdList.unshift(node.data.id);
                    }
                    while (!!node.parent) {
                        node = node.parent;
                        if(node.level != 0) {
                            parentIdList.unshift(node.data.id);
                        }
                    }
                    parentIdList.unshift(0);
                    this.editExpandArray = parentIdList;
                    setTimeout(() => {
                        this.$refs.editTree.setCurrentKey(menuNode ? menuNode.pid :this.permissionDetail.pid);
                    }, 500);
                    if ((menuNode === null && this.currentNode.pId == 0) || (menuNode && menuNode.pid == 0)) {
                        this.addPermissionRootForm = {
                            name: '',
                            systemType: ''
                        };
                        this.isShowEditPermissionRootDialog = true;
                    } else {

                        queryModuleByModel()
                            .then(data => {
                                this.isShowEditPermissionDialog = true;
                                this.moduleAppList = data || [];
                                this.moduleAppListSelect = data ? JSON.parse(JSON.stringify(data)) : [];
                            });
                    }

                }
            },
            editPermissionConfirm() {
                this.$refs.editPermissionForm.validate(isValid => {
                    if (isValid) {
                        const args = {
                            description: this.editPermissionForm.description,
                            label: this.editPermissionForm.label,
                            moduleId: this.editPermissionForm.moduleId || '',
                            id: this.editPermissionForm.id,
                            pid: this.editPermissionForm.pid,
                            url: this.editPermissionForm.url,
                            name: this.editPermissionForm.name,
                            type:this.editPermissionForm.type
                        };
                        updatePermission(args)
                            .then(() => {
                                this.isShowPermissionRole = false;

                                this.$message.success('编辑成功');
                                this.isShowEditPermissionDialog = false;
                                this.queryPermissionTreeFunc();
                                this.queryPermissionByPidFunc();
                            });
                    }
                })
            },
            editPermissionRootConfirm() {
                this.$refs.editPermissionRootForm.validate(isValid => {
                    if (isValid) {
                        const args = {
                            description: '',
                            label: '',
                            moduleId: '',
                            systemType: this.editPermissionRootForm.systemType,
                            pid: this.editPermissionRootForm.pid,
                            id: this.editPermissionRootForm.id,
                            url: '',
                            name: this.editPermissionRootForm.name,
                            type: this.currentType
                        };
                        updatePermission(args)
                            .then(() => {
                                this.isShowPermissionRole = false;

                                this.$message.success('编辑成功');
                                this.isShowEditPermissionRootDialog = false;
                                this.queryPermissionTreeFunc();
                                this.queryPermissionByPidFunc();
                            });
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    #permission {
        height: 100%;
    }

    .tree-header {
        padding: 12px;
        top: 0;

        & > div:first-of-type {
            margin-bottom: 12px;
        }
    }

    .tree-header--placeholder {
        height: 94px;
    }

    .tree-container {
        height: 300px;
        overflow-y: auto;
        @include scrollBar;
        width: 260px;

    }

    .tree-panel {
        position: relative;
        float: left;
        width: 260px;
        border-right: 1px solid #f1f1f1;
    }

    .main-panel {
        float: left;
        padding: 12px;
    }

    .title {
        margin: 10px 0;
        border-left: 4px solid #409EFF;
        padding-left: 12px;
        height: 16px;
        line-height: 16px;
    }

    .line {
        margin: 20px 0;

        .label, .value {
            display: inline-block;
            vertical-align: top;
        }

        .label {
            width: 7em;
            margin-right: 10px;
            text-align: right;
        }

        .value {
            word-break: break-all;
            line-height: 21px;
        }

    }
    .resource-name {
        color: #409EFF;
        cursor: pointer;
    }
    .role-list {
        margin-top: 30px;
        @include clearfix;
        .role-item {
            float: left;
            margin-right: 10px;
        }
    }
    .title--large {
        margin: 30px 0;
    }
    .info-line {
        color: #606266;
        margin-bottom: 10px;
        .info-line__name {
            font-size: 24px;
            margin-right: 24px;
        }
        .info-line__value {
            color: #409EFF;
            margin-right: 24px;
        }
    }
</style>
<style lang="scss">
    .dialog-form .is-current.is-focusable > .el-tree-node__content {
        background-color: #20a0ff !important;
        color: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/permission/permission.vue